<script>
import { locale, translations, getBrowserLocale } from 'svelte-intl';
import Page from './components/Page.svelte';
import BookingsTable from './components/BookingsTable.svelte';

import en from './i18n/en.json';
import fr from './i18n/fr.json';
translations.update({ en, fr });

// path split
const uri = window.location.pathname;
const pathParts = uri.split('/');
  // default date -- today
let formDate = new Date().toISOString().substr(0,10);
let formLang = '';

pathParts
  .filter(part => part !== '')
  .forEach(part => {
    if (/^(\d){4}-(\d){2}-(\d){2}(\-(am|pm))?$/i.test(part)) {
      formDate = part;
    } else if (part.length === 2) {
      formLang = part;
    }
  });

if (formLang === '') {
  try {
    const storedLang = localStorage.getItem('lang');
    if (storedLang) {
      formLang = storedLang;
    } else {
      formLang = getBrowserLocale('en');
    }
  } catch(e) {
    formLang = getBrowserLocale('en');
    console.error('Error when trying to access localStorage');
  }
}

// set the language
locale.set(formLang);
</script>

{#if uri === '/bookings'}
  <BookingsTable />
{:else}
  <Page date={formDate}></Page>
{/if}


<style global>
:global(html) {
  font-size: 62.5%;
}

:global(html), :global(body) {
  margin: 0;
}

:global(body) {
  padding-bottom: 7rem;
  background-size: cover;
  background-repeat: no-repeat;
  font-weight: 300;
  min-height: 100vh;
  background-position: center center;
  background-attachment: fixed;
}

:global(body:after) {
  position: fixed;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  background: rgb(237,29,36);
  background: -moz-linear-gradient(-45deg,  rgba(237,29,36,1) 0%, rgba(0,181,176,1) 100%);
  background: -webkit-linear-gradient(-45deg,  rgba(237,29,36,1) 0%,rgba(0,181,176,1) 100%);
  background: linear-gradient(135deg,  rgba(237,29,36,1) 0%,rgba(0,181,176,1) 100%);
  opacity: 0.7;
}

@media(max-width: 767px) {
  :global(body) {
    background-attachment: scroll;
    background-size: contain;
    background-position: 10% -10%;
    padding-bottom: 0;
  }

  :global(body:after) {
    background: -moz-linear-gradient(left, rgba(237,29,36,1) 0%, rgba(0,181,176,1) 100%);
    background: -webkit-linear-gradient(left, rgba(237,29,36,1) 0%,rgba(0,181,176,1) 100%);
    background: linear-gradient(to right, rgba(237,29,36,1) 0%,rgba(0,181,176,1) 100%);
  }
}

@media(max-width: 1024px) {
  :global(body) {
    height: auto
  }
}

/*
  WTF?
  isn't enough to have smooting only on body?
*/
:global(*) {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


/*
  TODO: move these styles to the corresponding components
*/
:global(body),
:global(p),
:global(input),
:global(button),
:global(address) {
  font-size: 1.8rem;
  font-family: "Barlow", sans-serif;
}

:global(select) {
  font-size: 1.6rem;
  font-family: "Barlow", sans-serif;
}

:global(input:focus), 
:global(button:focus),
:global(select:focus) {
  outline: 0;
}
</style>
